export default {
  header: 'Mis Puntos de Instalación',
  navLink: '/app/my-places',
  children: []
}
